import React from 'react';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import CardContent from '@material-ui/core/CardContent';
import SectionHeader from '../../CherrySoftware/components/SectionHeader';
import GlassCard from '../../CherrySoftware/components/GlassCard';
import IconBadge from '../../CherrySoftware/components/IconBadge';
import CheckList from '../../CherrySoftware/components/CheckList';
import { metaAds } from '../sortilegioContent';

const MetaAds = () => {
  const theme = useTheme();

  return (
    <Box py={{ xs: 8, md: 10 }}>
      <SectionHeader
        overline={metaAds.overline}
        title={metaAds.title}
        subtitle={metaAds.subtitle}
        icon="dashboard"
        align="left"
        maxWidth="100%"
      />

      <Box
        data-aos="fade-up"
        mb={4}
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          bgcolor: theme.palette.primary.dark,
          color: theme.palette.common.white,
        }}
      >
        <Typography variant="overline" sx={{ fontWeight: 800, letterSpacing: 1.4, opacity: 0.85 }}>
          {metaAds.what.title}
        </Typography>
        <Typography variant="h6" component="p" sx={{ fontWeight: 500, lineHeight: 1.7, mt: 1 }}>
          {metaAds.what.text}
        </Typography>
      </Box>

      <Grid container spacing={3} mb={5}>
        {metaAds.why.map((item, index) => (
          <Grid item xs={12} md={4} key={item.title}>
            <GlassCard data-aos="fade-up" accentPalette={index === 1 ? 'secondary' : 'primary'}>
              <CardContent sx={{ p: 3 }}>
                <Box mb={2}>
                  <IconBadge
                    icon={item.icon}
                    color={index === 1 ? 'secondary' : 'primary'}
                    variant="gradient"
                    size={44}
                    rounded="12px"
                  />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 800, mb: 1.5, lineHeight: 1.3 }}>
                  {item.title}
                </Typography>
                <Typography color="textSecondary" sx={{ lineHeight: 1.75 }}>
                  {item.text}
                </Typography>
              </CardContent>
            </GlassCard>
          </Grid>
        ))}
      </Grid>

      <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
        {metaAds.howTitle}
      </Typography>
      <Typography color="textSecondary" sx={{ lineHeight: 1.7, mb: 3, maxWidth: 820 }}>
        {metaAds.howIntro}
      </Typography>

      <Grid container spacing={3}>
        {metaAds.how.map((column, index) => (
          <Grid item xs={12} md={6} key={column.owner}>
            <GlassCard hover={false} accentPalette={index === 0 ? 'secondary' : 'primary'}>
              <Box
                sx={{
                  px: 3,
                  py: 1.5,
                  bgcolor: alpha(
                    index === 0 ? theme.palette.secondary.main : theme.palette.primary.main,
                    0.1,
                  ),
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
                }}
              >
                <Typography variant="caption" color={index === 0 ? 'secondary' : 'primary'} sx={{ fontWeight: 800 }}>
                  {column.owner}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 800, mt: 0.25 }}>
                  {column.title}
                </Typography>
              </Box>
              <Box p={3}>
                <CheckList items={column.items} dense />
              </Box>
            </GlassCard>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default MetaAds;
